// extracted by mini-css-extract-plugin
module.exports = {"collapses-box":"collapses-box___1Knup","collapses-box-item":"collapses-box-item___HCZ4y"};